import {BranchLocationOpeningHoursApiDto, MerchantBranchLocationApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";

export default class MerchantBranchLocation {
	constructor(
		public readonly id: string,
		public readonly name: string,
		public readonly merchantId: string,
		public readonly siteId: string,
		public readonly phone: string,
		public readonly email: string,
		public readonly openingHours: Option<BranchLocationOpeningHoursApiDto>
	) {}

	static fromJson(json: MerchantBranchLocationApiDto): MerchantBranchLocation {
		return new MerchantBranchLocation(json.id, json.name, json.merchantId, json.siteId, json.phone, json.email, option(json.openingHours));
	}
}